<script lang="ts">
    import mapComponent from './mappers/index';
    import { onMount } from 'svelte';
    import { page } from '$app/stores';
    import { TRANSITION_DELAY } from '$lib/global/constants';
    import { DEFAULT_LAYOUT } from '$lib/components/constants';

    // Types
    import type { Component } from '$lib/types/Components/SharedTypes';
    import type { Field } from '$lib/types/Field';
    import type { TrackingProperty } from '$lib/types/TrackingProperty';
    import type { Theme, TransitionEffect } from '$lib/types/Theme';
    import type { ResultMapping } from '$lib/types/ResultMapping';
    import type { Language } from '$lib/types/Language';

    let ready = false;

    onMount(() => (ready = true));

    export let id = '';
    export let content = {};
    export let childComponents: Component[] = [];
    export let resultMapping: ResultMapping;
    export let theme: Theme;
    export let nextPage = '';
    export let currentPage = '';
    export let componentType = '';
    export let campaignId = '';
    export let companyId = '';
    export let cookiesEnabled = false;
    export let fields: Field[] = [];
    export let index = 0;
    export let firstResultPage = '';
    export let trackingProperties: TrackingProperty[] = [];
    export let language: Language = 'de';
    export let layout = DEFAULT_LAYOUT;

    const transitionEffect: TransitionEffect = $page?.data?.theme?.transition || 'none';

    $: svelteComponent = mapComponent(componentType, content);
    $: transitionDelay = index * TRANSITION_DELAY;
</script>

{#if ready}
    {#if svelteComponent}
        <svelte:component
            this={svelteComponent}
            {id}
            {content}
            {theme}
            {currentPage}
            {nextPage}
            {childComponents}
            {resultMapping}
            {campaignId}
            {companyId}
            {cookiesEnabled}
            {fields}
            {firstResultPage}
            {transitionDelay}
            {transitionEffect}
            {trackingProperties}
            {language}
            {layout}
        />
    {/if}
{/if}
